import { useState, useEffect, useRef } from 'react';
import { Search } from 'lucide-react';

function ChatSearchBar({ chats, searchQuery, onSearchQueryChange, onFiltered, onSearchLoading }) {
  const [loading, setLoading] = useState(false);
  const debounceTimer = useRef(null);

  const handleChange = (value) => {
    onSearchQueryChange(value);

    // Clear previous timer
    if (debounceTimer.current) {
      clearTimeout(debounceTimer.current);
    }

    // Filter already loaded chats by last_message only
    // TODO: Add name search by loading profiles or using Supabase RPC
    const filtered = value.trim()
      ? chats.filter((c) => {
          const lastMessage = c.last_message || '';
          return lastMessage.toLowerCase().includes(value.toLowerCase());
        })
      : chats;

    onFiltered(filtered);

    // Debounce Supabase search
    if (value.trim()) {
      setLoading(true);
      onSearchLoading?.(true);

      debounceTimer.current = setTimeout(() => {
        // TODO: Call Supabase search RPC here
        // Check kindred example for search_by_name_in_chats RPC
        // For now, just clear loading state
        setLoading(false);
        onSearchLoading?.(false);
      }, 500);
    } else {
      setLoading(false);
      onSearchLoading?.(false);
    }
  };

  useEffect(() => {
    return () => {
      if (debounceTimer.current) {
        clearTimeout(debounceTimer.current);
      }
    };
  }, []);

  return (
    <div className="sticky top-0 z-10 border-b border-border bg-background/80 px-4 py-2 backdrop-blur">
      <div className="flex items-center gap-2 rounded-full border border-input bg-background px-3 py-1.5">
        <Search size={16} className="shrink-0 text-muted-foreground" />
        <input
          type="text"
          value={searchQuery}
          onChange={(e) => handleChange(e.target.value)}
          placeholder="Search chats..."
          className="flex-1 border-none bg-transparent text-sm text-foreground outline-none placeholder:text-muted-foreground"
        />
      </div>
    </div>
  );
}

export default ChatSearchBar;
